import { IdAssetBundleCalloutIcons } from "../../assetBundles/IdAssetBundleCalloutIcons";
import { BF2CreateAsset } from "../BF2BuildingGraphicsUtils";
var Container = PIXI.Container;
export var BF2GetExclamationMarkCallouts = function () {
    var container = new Container();
    var config = [
        {
            id: IdAssetBundleCalloutIcons.CallOutWhite,
        },
        {
            id: IdAssetBundleCalloutIcons.ExclamationMarkIcn,
            offset: [0, -10],
        },
    ];
    var assets = config.map(function (cfg) { return BF2CreateAsset(cfg); });
    if (assets) {
        container.addChild.apply(container, assets);
    }
    return container;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetExclamationMarkCallouts.ts
// module id = 2148
// module chunks = 3